// extracted by mini-css-extract-plugin
module.exports = {"styles":"_11jSRV5EM_1hSGj5XTgwO5"};